import { Application } from "@hotwired/stimulus";
import SortableParagraphsController from "../src/decidim/participatory_texts/controllers/sortable_paragraphs_controller";
import CommentFeedbacksController from "../src/decidim/participatory_texts/controllers/comment_feedbacks_controller";
import MergeParagraphsController from "../src/decidim/participatory_texts/controllers/merge_paragraphs_controller";
import ParagraphNavigateController from "../src/decidim/participatory_texts/controllers/paragraph_navigate_controller";
import "../stylesheets/decidim/participatory_texts/participatory_texts.scss";
const application = window.Stimulus || Application.start();
application.register("sortable-paragraphs", SortableParagraphsController);
application.register("comment-feedbacks", CommentFeedbacksController);
application.register("merge-paragraphs", MergeParagraphsController);
application.register("paragraph-navigate", ParagraphNavigateController);
